import React from "react";
import HeroImage from "../../images/hero/hero-cross-sell.png";
import { __ } from "@wordpress/i18n";

const HeroSection = () => {
  return (
    <div className="cross-sell-hero">
      <div className="cross-sell-wrapper cross-sell-hero__wrapper">
        <div className="cross-sell-hero__image">
          <img src={HeroImage} alt="WPMU DEV Plugins" />
        </div>
        <div className="cross-sell-hero__content">
          <h2>
            {__(
              "We heard you like plugins...😉",
              "plugin-cross-sell-textdomain"
            )}
          </h2>
          <p>
            {__(
              "Check out these top-rated tools for securing, optimizing and growing your site.",
              "plugin-cross-sell-textdomain"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export { HeroSection };
